import Vue from "vue";

export enum PermissionName {
  PERMISSION_VIEW = "Permission_View",
  ROLE_VIEW = "Role_View",
  ROLE_CREATE = "Role_Create",
  ROLE_EDIT = "Role_Edit",
  ROLE_DELETE = "Role_Delete",
  USER_VIEW = "User_View",
  USER_CREATE = "User_Create",
  USER_EDIT = "User_Edit",
  USER_DELETE = "User_Delete",
  PROMOTION_VIEW = "Promotion_View",
  PROMOTION_CREATE = "Promotion_Create",
  PROMOTION_EDIT = "Promotion_Edit",
  PROMOTION_DELETE = "Promotion_Delete",
  MIGRATE_ACTION = "Migrate_Action",
  DUPLICATE_VIEW = "Duplicate_View",
  DUPLICATE_DELETE = "Duplicate_Delete",
  DUPLICATE_MARK = "Duplicate_Mark",
  FIX_ACTION = "Fix_Action",
  CREATE_SHOP_NOTI_TOKEN = "Create_Shop_Noti_Token",
  SHOPIFY_CREATE = "Shopify_Create",
  SHOPIFY_UPDATE = "Shopify_Edit",
  SHOPIFY_VIEW = "Shopify_View",
  SHOPIFY_DELETE = "Shopify_Delete",
  MARKETPLACE_STOP_SYNC = "Marketplace_Stop_Sync",
  APPLY_PROMOTION_ERROR_TRACKING_VIEW = "Apply_Promotion_Error_Tracking_View",
  APPLY_PROMOTION_ERROR_TRACKING_ACTION = "Apply_Promotion_Error_Tracking_Action",
  SHOP_DELIVERY_SET_ATTRIBUTE = "Shop_Delivery_Set_Attribute",
  INCORRECT_INVENTORY_ERROR_TRACKING_VIEW = "Incorrect_Inventory_Error_Tracking_View",
  DELIVERY_RAW_STATUS_MAPPING = "Delivery_Raw_Status_Mapping",
  SHIPNITY_CREATE = "Shipnity_Create",
  SHIPNITY_UPDATE = "Shipnity_Edit",
  SHIPNITY_VIEW = "Shipnity_View",
  SHIPNITY_DELETE = "Shipnity_Delete",
  LINE_CREATE = "Line_Create",
  LINE_UPDATE = "Line_Edit",
  LINE_VIEW = "Line_View",
  LINE_DELETE = "Line_Delete",
  API_BRIDGE_ACTION = "Api_Bridge_Action",
  SHIPPOP_COD_CREATE = "Shippop_Cod_Create",
  UPDATE_DELIVERY_MODE = "Update_Delivery_Mode",
  TMS_REGISTRATION = "TMS_Registration",
  HOLD_ORDER_STATUS = "Hold_Order_Status",
  HOLD_ORDER_LIST = "Hold_Order_List",
  ERROR_EVENT_NOTIFICATION = "Error_Event_Notification",
  LINE_STOP_SYNC = "Line_Stop_Sync",
  UPDATE_MC_STATUS_TO_5 = "Update_Mc_Status_To_5"
}

export default Vue.extend({
  methods: {
    hasPermission(permissionName: PermissionName) {
      return (this as any).$dep.authUseCase.hasPermission(permissionName);
    }
  }
});
